import axios from "axios";

const baseURL = process.env.REACT_APP_BE_BASE_URL || "/backend";
const basePublicUrl = process.env.PUBLIC_URL || "/";

const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers":
      // eslint-disable-next-line max-len
      "POST, GET, PUT, PATCH, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin",
    "Content-Type": "application/json",
  },
  timeout: 10000,
});

// Interceptor para manejar la autorización
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const isForbidden = error.response?.status === 403;

    if (isForbidden) {
      const redirectBase = basePublicUrl.endsWith("/") ? basePublicUrl.slice(0, -1) : basePublicUrl;
      window.location.href = `${redirectBase}/403`;
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
